import React from "react";
import { Layout, Row, Col, BackTop } from "antd";
import { URL } from "screen/00_Nav/url";
import { useSelector } from "react-redux";
import { draftBailiffDetailSelector } from "store/bailiff/draft/bailiff/draft_bailiff.selector";
//
//component
import LayoutHeader from "screen/00_Nav/layout/layout_header";
import SectionCointaner from "component/sections/section_container";
import TriggerInit from "./trigger/trigger_init";
import DetailHeader from "./component/detail_header";
import DetailTable from "./component/detail_table";
import DialogPageEstimate from "./dialog/dialog_page_estimate";
import DetailForward from "./component/detail_forward";
import DetailTabs from "./component/detail_tabs";
import DetailPreview from "./component/detail_preview";
import DialogPreviewSegment from "./dialog/dialog_review_segment";
import TriggerPreview from "./trigger/trigger_preview";
import DialogSpeakerAdd from "./dialog/dialog_speaker_add";
import TriggerMerge from "./trigger/trigger_merge";
import TriggerComment from "./trigger/trigger_comment";
import TriggerSpeakers from "./trigger/trigger_speaker";

//redux
//selector
//actions
//utils
//hook
//str

const BailiffDetail = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(draftBailiffDetailSelector);
  const name = detail?.name;
  const id = detail?.id;

  const breadCrum = [
    {
      title: "Bailiff",
      url: URL.home,
    },
    {
      title: name,
      url: "/bailiff" + `/${id}`,
    },
  ];
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row gutter={[10, 20]}>
        <Col xl={18} lg={18} md={18} xs={24}>
          <DetailHeader />
        </Col>
        <Col align="right" xl={6} lg={6} md={6} xs={24}>
          <DetailForward />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <DetailTabs />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <DetailTable />
          <DetailPreview />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Layout id="bailiff-screen">
      <LayoutHeader title="Bailiff Listing" />
      <SectionCointaner breadCrum={breadCrum}>
        <div style={{ padding: 20 }}>{renderBody()}</div>
      </SectionCointaner>
      <DialogPageEstimate />
      <DialogPreviewSegment />
      <DialogSpeakerAdd />
      <TriggerInit />
      <TriggerPreview />
      <TriggerMerge />
      <TriggerComment />
      <TriggerSpeakers />
      <BackTop style={{ zIndex: 99 }} />
    </Layout>
  );
};
export default BailiffDetail;
